import { HelpCircle } from 'lucide-react';
import { useState } from 'react';


export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  
  const faqs = [
    {
      question: "What is the contract address?",
      answer: "The official $QGEN contract address is SOL: FV5xbhjTUCw4iX7cHYYX7o9Fi5BwXFJMpF1zpYJMoAfY ETH: 0x09B80bD7a13F5B374a7A6c57600CC75F595e21c1. ⚠️ Never send tokens manually to any address shown here. Always use the presale widget to ensure your purchase is recorded properly."
    },
    {
      question: "What is Quantum Genesis?",
      answer: "Quantum Genesis is a futuristic meme coin and game universe where quantum tech meets blockchain chaos. It's more than a token — it's the beginning of a resistance against quantum AI domination, powered by NFTs, staking, and community-driven lore."
    },
    {
      question: "How can I participate in the presale?",
      answer: "Join the Genesis resistance by connecting your wallet and purchasing $QGEN using ETH, BNB, USDT, USDC, SOL or even a credit cardthrough our secure presale widget. Early adopters gain perks, bonus tokens, and early access to our NFT missions."
    },
    {
      question: "What is the tokenomics of $QGEN?",
      answer: "$QGEN has a fixed supply of 1 billion tokens. Allocation supports presale (community), liquidity, staking rewards, marketing, core team, and development of the Quantum Genesis ecosystem — including our upcoming NFT and game modules."
    },
    {
      question: "How does staking work?",
      answer: "Stake your $QGEN to earn passive rewards and unlock exclusive in-game advantages. The longer you stake, the more you gain — including early access to rare NFTs and story-driven missions."
    },
    {
      question: "When will the token be listed on exchanges?",
      answer: "$QGEN will be listed on major DEXs after the presale concludes. Listings on centralized exchanges (CEXs) will follow. Stay tuned via our social media for exact dates and launch partners."
    }
  ];
  

  return (
    <div className="py-20 md:pt-80 md:pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center mb-12">
          <h2 className="font-tokyo text-4xl font-bold bg-gradient-to-r from-quantum-primary to-quantum-secondary bg-clip-text text-transparent mb-4 relative z-10">
            Frequently Asked Questions
          </h2>
          <p className="text-quantum-light/80 max-w-2xl mx-auto">
            Get answers to common questions about Quantum Genesis
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          {/* Kaitovorn SVG positioned at the top */}
          <div className="opacity-80 absolute left-1/2 -translate-x-1/2 -top-[17rem] md:-top-[26rem] w-full max-w-2xl -z-10 pointer-events-none">
            <img
              src="gif/kaitovorn.svg"
              alt="Kaitovorn"
              className="w-full h-auto"
            />
          </div>

          <div className="space-y-4 relative z-0">
            {faqs.map((faq, index) => (
              <div key={index} className="quantum-card">
                <button
                  className="w-full p-6 text-left flex justify-between items-center"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-lg font-medium text-quantum-light">{faq.question}</span>
                  <HelpCircle className={`w-5 h-5 transition-transform duration-200 ${
                    openIndex === index ? 'transform rotate-180' : ''
                  }`} />
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-6 text-quantum-light/80">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}